export default "__VITE_ASSET__CcDcDXp9__"